import useJwt from '@/auth/jwt/useJwt';

/**
 * Return if user is logged in
 * This is completely up to you and how you want to store the token in your frontend application
 * e.g. If you are using cookies to store the application please update this function
 */
// eslint-disable-next-line arrow-body-style
export const isUserLoggedIn = () => {
  return (
    localStorage.getItem('userData') &&
    localStorage.getItem(useJwt.jwtConfig.storageTokenKeyName)
  );
};

export const getUserData = () => JSON.parse(localStorage.getItem('userData'));

/**
 * This function is used for demo purpose route navigation
 * In real app you won't need this function because your app will navigate to same route for each users regardless of ability
 * Please note role field is just for showing purpose it's not used by anything in frontend
 * We are checking role just for ease
 * NOTE: If you have different pages to navigate based on user ability then this function can be useful. However, you need to update it.
 * @param {String} userRole Role of user
 */
export const getHomeRouteForLoggedInUser = (userRole) => {
  // Convert role to lowercase for case-insensitive comparison
  const role = userRole?.toLowerCase();
  console.log("role-utils", role);
  switch (role) {
    case 'super-admin':
      return '/main-dashboard';  // First route from main-dashboard.js
    case 'reception':
      return '/Reception-Departments';  // First route from reception-department.js (lines 3-10)
    case 'clinic':
      return '/clinic-department';  // First route from clinic-department.js
    case 'emergency':
      return '/emergency';  // First route from emergency-department.js
    case 'lab':
      return '/patients-lab';  // First route from lab-department.js
    case 'radiology':
      return '/radiology';  // First route from radiology-department.js
    case 'warehouse':
      return '/warehouse';  // First route from warehouse-department.js
    case 'pharmacy':
      return '/patients-has-drugs';  // First route from pharmacy-department.js
    case 'bloodbank':
      return '/blood-store';  // First route from bloodBank-routes.js
    case 'accounting':
      return '/surgery-accounting';  // First route from accounting-router.js
    case 'consultant':
      return '/consultant-dashboard';  // First route from consultant-department.js
    case 'chemotherapy':
      return '/chemotherapy-dashboard';  // First route from chemotherapy-department.js
    case 'ivf':
      return '/ivf-expenses';  // First route from ivf-routes.js
    case 'seniorhouseoffice':
      return '/senior-house-office';  // First route from seniorHouseOffice-routes.js (lines 3-6)
    case 'surgery':
      return '/surgery';  // First route from surgery-department.js (lines 3-6)
    default:
      return '/Reception-Departments';  // Default fallback to reception
  }
};
